// extracted by mini-css-extract-plugin
export var layoutContainer = "_b0-0";
export var layoutContainerNoRounding = "_b0-6";
export var layoutContainerOpen = "_b0-5";
export var layoutContainerResizing = "_b0-1";
export var mainContent = "_b0-2";
export var resizeDivider = "_b0-3";
export var slidePanel = "_b0-4";